import React from 'react';
import _ from 'lodash';

import {
  Button,
  Popover,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography
} from '@mui/material';

import { MoreHoriz } from '@mui/icons-material';
import { styled } from '@mui/material/styles';



const RowPopoverButton = styled(Button)(() => ({
  padding: 0
}));

const ListItemTypography = styled(Typography, {
  shouldForwardProp: prop =>
    prop !== 'isDangerous'
})<{isDangerous?: boolean;}>(({theme, isDangerous}) => ({
  fontSize: 14,
  fontWeight: 600,
  color: isDangerous ?
    theme.palette.error.main :
    undefined
}));



export interface IPopoverOption {
  id: string;
  label: string;
  isDangerous?: boolean;
  show?: boolean;
}

export interface IProps {
  options: IPopoverOption[];
  onClickOption: (id: string) => void;
  isInFooter?: boolean;
}

export const FC: React.FC<IProps> = props => {
  const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);

  const refPopoverButton = React.useRef<HTMLButtonElement>(null);



  const filteredOptions = React.useMemo(
    () => _.filter(props.options, option =>
      _.isUndefined(option.show) || option.show),
    [props.options]
  );



  function handleClickOption(id: string) {
    setIsPopoverOpen(false);
    props.onClickOption(id);
  }



  return (
    <>
      <RowPopoverButton
        ref={refPopoverButton}
        variant="text"
        size="small"
        onClick={() => setIsPopoverOpen(true)}>
        <MoreHoriz
          htmlColor="#6B788B" />
      </RowPopoverButton>

      <Popover
        open={isPopoverOpen}
        anchorEl={refPopoverButton.current}
        onClose={() => setIsPopoverOpen(false)}
        anchorOrigin={!props.isInFooter ? {
          vertical: 'bottom',
          horizontal: 'right'
        } : {
          vertical: 'top',
          horizontal: 'left'
        }}
        transformOrigin={!props.isInFooter ? {
          vertical: 'top',
          horizontal: 'right'
        } : {
          vertical: 'bottom',
          horizontal: 'left'
        }}>

        <List disablePadding>
          {_.map(filteredOptions, option => (
            <ListItem
              key={option.id}
              disablePadding>
              <ListItemButton
                dense
                onClick={() => handleClickOption(option.id)}>
                <ListItemText disableTypography>
                  <ListItemTypography
                    isDangerous={option.isDangerous}>
                    {option.label}
                  </ListItemTypography>
                </ListItemText>
              </ListItemButton>
            </ListItem>
          ))}
        </List>

      </Popover>
    </>
  );
};
